// src/pages/HSE.jsx
import React from 'react';
import hseBg from '../assets/images/companyImg.JPG'; // Import your background image for HSE

function HSE() {
  return (
    // Outermost div: Acts as the container for the entire page and its background
    <div className="position-relative overflow-hidden">
      {/* Background Image Layer: Positioned absolutely to cover the entire outermost div */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${hseBg})`, // Use the imported background image
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed', // Makes the background image static (parallax effect)
          opacity: 0.3, // Adjust opacity as needed for readability
          zIndex: 0, // Ensures it's behind the content
        }}
      ></div>

      {/* Main Content Wrapper: All visible page content goes here, positioned above the background */}
      <div className="container py-5 position-relative z-1"> {/* Added position-relative and z-1 */}
        <h1 className="mb-4 text-center display-4 fw-bold text-dark">Health, Safety & Environment (HSE)</h1>
        <p className="lead text-center mb-5 ">
          At LIYO & SONS GROUP (PTY) Ltd, we are committed to creating and maintaining a safe, healthy, and environmentally
          responsible workplace. Our HSE Management System complies with national legislation and international standards,
          including ISO 14001:2015 and ISO 45001:2018.
        </p>

        {/* HSE Management System (HSEMS) */}
        <section className="py-3 mb-5 position-relative  z-1"> {/* Changed bg-light to bg-white and added z-1 */}
          <div className="row justify-content-center">
            <div className="col-lg-10 text-dark ">
              <h3 className="mb-4 text-center ">HSE Management System (HSEMS)</h3>
              <p className="text-center mb-4">
                Our HSEMS ensures a continual improvement cycle by reducing onsite risks and optimizing safety procedures across
                all projects.
              </p>
              <div className="row row-cols-1  row-cols-md-2 row-cols-lg-3 g-4">
                {/* Policy & Commitment */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-file-earmark-text display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Policy & Commitment</h5>
                    </div>
                  </div>
                </div>
                {/* Planning & Organization */}
                <div className="col ">
                  <div className="card h-100 border-0 shadow-sm ">
                    <div className="card-body  bg-white text-center">
                      <i className="bi bi-calendar-check display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Planning & Organization</h5>
                    </div>
                  </div>
                </div>
                {/* Procedures & Practices */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-clipboard-check display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Procedures & Practices</h5>
                    </div>
                  </div>
                </div>
                {/* Checking & Corrective Actions */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-search display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Checking & Corrective Actions</h5>
                    </div>
                  </div>
                </div>
                {/* Management Review */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-person-check display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Management Review</h5>
                    </div>
                  </div>
                </div>
                {/* Continual Improvement */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-arrow-repeat display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Continual Improvement</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* HSE Policy */}
        <section className="py-3 mb-5 position-relative z-1 text-dark"> {/* Added bg-white and z-1 */}
          <h3 className="mb-4 text-center">HSE Policy</h3>
          <p className="text-center mb-4">
            Our HSE Policy is signed by our Managing Director and embraced throughout all levels of management to ensure:
          </p>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <ul className="list-group list-group-flush shadow-sm rounded-3">
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-success me-3"></i>
                  Compliance with legal and environmental safety regulations.
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-success me-3"></i>
                  Protection of employee health and prevention of occupational diseases.
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-success me-3"></i>
                  Commitment to protecting the environment and the community.
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-success me-3"></i>
                  Promotion of awareness and employee involvement in HSE matters.
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-success me-3"></i>
                  Allocation of resources to maintain and improve safety and performance.
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Our Core Values */}
        <section className="py-3  mb-5 position-relative z-1 text-dark"> {/* Changed bg-light to bg-white and added z-1 */}
          <h3 className="mb-4 text-center">Our HSE Principles</h3>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row row-cols-1 row-cols-md-2 g-4">
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-lightbulb display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Proactiveness</h5>
                      <p className="card-text text-dark">Always preparing for challenges and seeking continuous improvement.</p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-award display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Commitment</h5>
                      <p className="card-text text-dark">Staying true to promises and achieving success with clients and partners.</p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-shield-check display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Integrity</h5>
                      <p className="card-text text-dark">Honest communication, zero tolerance for bribery or concealment.</p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-center">
                      <i className="bi bi-people display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title text-dark">Cooperation</h5>
                      <p className="card-text text-dark">Clear communication, openness, and teamwork to ensure mutual growth.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> {/* End of main content wrapper */}
    </div> // End of outermost div
  );
}

export default HSE;
